var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.091,
    height: 17,
    viewBox: "0 0 23.091 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back",
    transform: "translate(0.591 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "back-2",
    "data-name": "back",
    d: "M22,11H4.414L9.707,5.707A1,1,0,1,0,8.293,4.293l-7,7a1,1,0,0,0,0,1.414l7,7a1,1,0,1,0,1.414-1.414L4.414,13H22a1,1,0,0,0,0-2Z",
    transform: "translate(-1 -4)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.cfcf7e75337505644766790fa8bae830.svg";
export { ForwardRef as ReactComponent };